<template>
  <main class="legal-page">
    <section class="legal-page__shell">
      <a class="legal-page__brand" href="/" aria-label="GuildGuardian Startseite">
        <MascotLogo />
        <span>GuildGuardian</span>
      </a>

      <header class="legal-page__header">
        <p>{{ page.eyebrow }}</p>
        <h1>{{ page.title }}</h1>
        <span>{{ page.subtitle }}</span>
      </header>

      <article class="legal-page__card">
        <div class="legal-page__meta">
          <span>{{ page.updatedLabel }}</span>
        </div>

        <section
          v-for="block in page.blocks"
          :key="block.title || (block.lines && block.lines[0]) || (block.paragraphs && block.paragraphs[0])"
          class="legal-page__block"
        >
          <h2 v-if="block.title">{{ block.title }}</h2>
          <div v-if="block.lines" class="legal-page__lines">
            <span v-for="line in block.lines" :key="line">{{ line }}</span>
          </div>
          <p v-for="paragraph in block.paragraphs" :key="paragraph">{{ paragraph }}</p>
        </section>
      </article>

      <a class="legal-page__back" href="/">
        {{ page.backLabel }}
      </a>
    </section>
  </main>
</template>

<script>
import MascotLogo from './MascotLogo.vue'

export default {
  name: 'LegalPage',
  components: {
    MascotLogo
  },
  props: {
    page: {
      type: Object,
      required: true
    }
  }
}
</script>
